
<template>

  <div class="hover-full">
    <h3 v-html="temp.title"></h3>
    <ul>
      <li v-for="node in temp.content">
        <h4 v-html="node.sub"></h4>
        <p v-html="node.body"></p>
      </li>
    </ul>
  </div>

</template>

<script>
  export default {

    data(){
      return {

      }
    },

    props: ['temp']

  }
</script>

<style scoped>

.hover-full {
  width: 275px;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #404342;
  border: none;
  color: #dce1ec;
  border: 1px solid #dce1ec;
  border-radius: 4px;
  padding: none;
  font-family: 'Roboto', sans-serif;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h3, h4, p {
  font-weight: lighter;
}

ul {
  /* width: 100%; */
  margin-left: -20px;
  margin-top: 5px;
  padding-top: 2px;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

h3 {
  color: lightblue;
  margin: 4px;
  /* width: 100%; */
}

li {
  list-style: none;
}

h4 {
  margin-bottom: 0px;
  margin-top: 5px;
}

p {
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/hover/Full.vue